
export const users = {
    state: {
        user: {},
        userLoadStatus: 0,
        userUpdateStatus: 0,

        authorizeLoadStatus: 0
    },

    actions: {
        loadUser({ commit }) {
            commit('setUserLoadStatus', 1);

            /*UserAPI.getUser()
                .then( function( response ){
                    commit( 'setUser', response.data );
                    commit( 'setUserLoadStatus', 2 );
                })
                .catch( function(){
                    commit( 'setUser', {} );
                    commit( 'setUserLoadStatus', 3 );
                });*/
        },
    },

    mutations: {
        setUserLoadStatus(state, status) {
            state.userLoadStatus = status;
        },

        setUser(state, user) {
            state.user = user;
        },

        setUserUpdateStatus(state, status) {
            state.userUpdateStatus = status;
        },

        setAuthorizeLoadStatus(state, status) {
            state.authorizeLoadStatus = status;
        },
    },

    getters: {
        getUserLoadStatus(state) {
            return state.userLoadStatus;
        },

        getUser(state) {
            return state.user;
        },

        getUserUpdateStatus(state, status) {
            return state.userUpdateStatus;
        },

        getAuthorizeLoadStatus(state) {
            return state.authorizeLoadStatus;
        },
    }
}
